import { Modal, ModalSection, Button, TextField } from '@monash/portal-react';
import c from './feedback-modal.module.scss';
import ConfirmationModal from './ConfirmationModal';
import { useState, useContext } from 'react';
import { AuthContext, fsUpdateDoc } from '@monash/portal-frontend-common';

const AdminNoteModal = ({
  open,
  title,
  placeholder,
  onClose,
  multiline = false,
  adminNotes,
  setAdminNotes,
  selectedNote,
  feedbackItem,
}) => {
  const [noteMessage, setNoteMessage] = useState(selectedNote?.message || '');
  const [confirmDelete, setConfirmDelete] = useState(false);
  const authCtx = useContext(AuthContext);

  const handleChange = (change) => {
    return setNoteMessage(change.target.value);
  };

  const openConfirmDelete = () => {
    setConfirmDelete(true);
  };

  const closeConfirmDelete = () => {
    setConfirmDelete(false);
  };

  const closeAdminNotes = () => {
    setConfirmDelete(false);
    setNoteMessage('');
    onClose(false);
  };

  const submitChanges = () => {
    if (!noteMessage) {
      return;
    }
    const editedDate = new Date().getTime();

    let updatedNotes;

    if (selectedNote?.dateEdited) {
      updatedNotes = adminNotes.map((note) => {
        if (note.dateEdited === selectedNote.dateEdited) {
          return {
            ...note,
            author: authCtx.user.displayName,
            message: noteMessage,
            dateEdited: editedDate,
          };
        }
        return note;
      });
    } else {
      const newNote = {
        author: authCtx.user.displayName,
        message: noteMessage,
        dateEdited: editedDate,
      };
      updatedNotes = [newNote, ...adminNotes];
    }
    setAdminNotes(updatedNotes);

    fsUpdateDoc(`surveyFeedback/${feedbackItem.id}`, {
      adminNotes: updatedNotes,
      history: [
        ...(feedbackItem?.history ?? []),
        {
          time: new Date().getTime(),
          type: 'Updated admin notes',
          user: {
            displayName: authCtx.user.displayName,
            email: authCtx.user.email,
          },
        },
      ],
    });

    setNoteMessage('');
    onClose(false);
  };

  return (
    <div>
      <ConfirmationModal
        open={confirmDelete}
        onCancel={closeConfirmDelete}
        onConfirm={closeAdminNotes}
        title="Are you sure you want to discard your changes?"
        message="Your changes will be lost."
      />
      <Modal open={open} onClose={openConfirmDelete} ariaLabel={title}>
        <ModalSection title={title}>
          <TextField
            onChange={(e) => handleChange(e)}
            placeholder={placeholder}
            multiline={multiline}
            value={noteMessage}
          />
          <div className={c.modalButtons}>
            <Button
              variant="text"
              size="medium"
              onClick={() => {
                openConfirmDelete();
              }}
            >
              Discard
            </Button>
            <Button
              size="medium"
              onClick={() => {
                submitChanges();
              }}
            >
              Save
            </Button>
          </div>
        </ModalSection>
      </Modal>
    </div>
  );
};

export default AdminNoteModal;
